import styled from 'styled-components'
import { SlideUpFrame, ExitSlideUpFrame } from '../../styles/keyframes'
export const StyledMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.5em;
`
export const StyledLinkWrapper = styled.div`
  display:flex;
  flex-direction: column;
  a, button {
    background: white;
    padding: 0.5rem 1.5rem;
    margin: 0.35rem;
    text-align: center;
    border-radius: 0.75rem;
    text-decoration: none;
    font-size: 1em;
    color: black;
    &:focus{
      outline-color: #fdfdfd;
    }
  }
`

export const Wrapper = styled.div`
  position:absolute;
  top: 0;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  .leaving {
    animation: ${ExitSlideUpFrame} 0.1s linear forwards;
  }
`
export const Mask = styled.div`
  background: rgba(0,0,0,0.7);
  height: 100%;
  width: 100%;
  position: absolute;
`
export const Container = styled.div`
  height: 100%;
  width: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  h1 {
    color: white;
    font-weight: 100;
    margin-bottom:0;
  }
  opacity: 0;
  animation: ${SlideUpFrame} 0.3s linear forwards;
`
export default StyledMenu
